import { render, staticRenderFns } from "./contract-agentshenpi.vue?vue&type=template&id=06c72826&scoped=true"
import script from "./contract-agentshenpi.vue?vue&type=script&lang=js"
export * from "./contract-agentshenpi.vue?vue&type=script&lang=js"
import style0 from "./contract-agentshenpi.vue?vue&type=style&index=0&id=06c72826&prod&lang=css"
import style1 from "./contract-agentshenpi.vue?vue&type=style&index=1&id=06c72826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c72826",
  null
  
)

export default component.exports